import { post } from '../../ReaderlyHttpClient';
import { ReviewData } from '../ItemService/Data';

export interface CreateReviewData {
  itemId: number;
  rating?: number | null;
  text: string;
}

class ReviewService {
  async create(data: CreateReviewData): Promise<ReviewData> {
    return await post<ReviewData, CreateReviewData>('Reviews', data);
  }
}

const reviewService = new ReviewService();
export default reviewService;
